<template>
  <div id="page_insights" class="column p0 minH100">
    <div class="cointainer_xl grid insights_grid">
      <div class="column_insights" style="grid-column: span 2 / span 2">
        <div class="component_card combo_1">
          <insights-supply
            @toggleModalCurrencies="showModalCurrencies('supply')"
          ></insights-supply>
        </div>

        <div v-if="modalCurrencies">
          <modalOtherCurrencies
            @toggleModalCurrencies="showModalCurrencies()"
            :type="type"
          />
        </div>

        <div v-if="modalCurrencyInfo">
          <modalCurrencyInfo
            @toggleModalCurrencies="showModalCurrencyInfo()"
            :selectedCurrency="selectedCurrency"
          />
        </div>

        <div v-if="modalPriceHist">
          <modalPriceHist
            @toggleModal="showModalPriceHist()"
            :priceHist="priceHistory"
          />
        </div>

        <div class="component_card combo_1">
          <general-charts
            @toggleModalExpandChart="showModalExpandChart()"
            @toggleModalPriceHist="showModalPriceHist()"
            @createPriceHist="(el) => createPriceHist(el)"
          ></general-charts>
        </div>

        <div v-if="modalExpandChart">
          <modalExpandChart @toggleModalExpandChart="showModalExpandChart()" />
        </div>

        <div class="component_card combo_1">
          <insights-reports></insights-reports>
        </div>
      </div>

      <div class="column_insights" style="grid-column: span 3 / span 3">
        <div class="component_card combo_1" style="border-bottom: 0rem">
          <insigths-holdings
            @toggleModal="(el) => showModalCurrencyInfo(el)"
          ></insigths-holdings>
        </div>
      </div>
    </div>
  </div>
</template> 
<script>
import { mapGetters } from "vuex";
import InsigthsHoldings from "../../components/private/insights/InsightsHoldings";
import InsightsReports from "../../components/private/insights/InsightsReports";
import GeneralCharts from "../../components/public/GeneralCharts";
import InsightsCharity from "../../components/private/insights/InsightsCharity";
import InsightsSupply from "../../components/private/insights/InsightsSupply";
import ModalOtherCurrencies from "../../components/modals/modalOtherCurrencies.vue";
import modalExpandChart from "../../components/modals/modalExpandChart";
import modalCurrencyInfo from "../../components/modals/modalCurrencyInfo";
import modalPriceHist from "../../components/modals/modalPriceHist";

export default {
  created() {},
  mounted() {},
  data: () => ({
    modalExpandChart: false,
    modalCurrencies: false,
    modalCurrencyInfo: false,
    modalPriceHist: false,
    type: "",
    selectedCurrency: {},
    priceHistory: {},
  }),
  components: {
    InsigthsHoldings,
    InsightsReports,
    GeneralCharts,
    InsightsCharity,
    InsightsSupply,
    ModalOtherCurrencies,
    modalExpandChart,
    modalCurrencyInfo,
    modalPriceHist,
  },
  methods: {
    showModalCurrencies(el) {
      this.type = el;
      this.modalCurrencies = !this.modalCurrencies;
    },
    showModalExpandChart() {
      this.modalExpandChart = !this.modalExpandChart;
    },

    createPriceHist(el) {
      this.priceHistory = el;

      console.log(el, "aqqqqqqqqqq");
    },

    showModalCurrencyInfo(el) {
      this.selectedCurrency = el;
      this.modalCurrencyInfo = !this.modalCurrencyInfo;
    },

    showModalPriceHist() {
      this.modalPriceHist = !this.modalPriceHist;
    },
  },
  computed: {
    ...mapGetters(["member", "currencies"]),
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/views/private/Insights.vue